<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "consumablesClass",
      key: "id",
      url: {
        get: "/admin/system/consumableType",
        add: "/admin/system/consumableType",
        edit: "/admin/system/consumableType",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "是否存在父级",
          name: "isParent",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 1,
              name: "否",
            },
            {
              value: 2,
              name: "是",
            },
          ],
          onChange: this.onisParent,
        },
        {
          label: "父级分类",
          name: "parentId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "耗材分类",
          name: "model",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "分类编号",
          name: "sigillum",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "是否是设备类型物资",
          name: "isEquipmentMaterials",
          type: "select",
          width: "400px",
          value: 1,
          dropList: [
            {
              value: 0,
              name: "否",
            },
            {
              value: 1,
              name: "是",
            },
          ],
          onChange: this.onDevice,
        },
        {
          label: "显示排序",
          name: "displaySequences",
          value: "",
          type: "number",
          min: 1,
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "textarea",
          width: "400px",
        },
      ],
      forms: {},
      editDetail: {},
    };
  },
  created() {
    let query = this.$route.query;
    if (query.action == "add") {
      this.loadLevelData();
      this.items[this.getItemIndex("parentId")].type = "kong";
      this.items[this.getItemIndex("isEquipmentMaterials")].type = "select";
    }
    if (query.action == "edit") {
      // this.items[this.getItemIndex("isParent")].disabled = true;
      // this.items[this.getItemIndex("parentId")].disabled = true;
      this.onEditLoad(query.kv);
    }
  },
  methods: {
    async onEditLoad(id) {
      let q = {
        id: id,
      };
      let res = await $utils.api.load(
        `/admin/system/consumableType/${id}`,
        q,
        "get"
      );
      console.log(res);
      if (res.code == 200) {
        this.editDetail = res.data;
        this.loadLevelData();
        if (res.data.isParent == 1) {
          this.items[this.getItemIndex("parentId")].type = "kong";
          this.items[this.getItemIndex("isEquipmentMaterials")].type = "select";
        } else {
          this.items[this.getItemIndex("isEquipmentMaterials")].type = "kong";
        }
      }
    },
    onisParent(val) {
      if (val == "1") {
        this.items[this.getItemIndex("parentId")].type = "kong";
        this.items[this.getItemIndex("isEquipmentMaterials")].type = "select";
      }
      if (val == "2") {
        this.items[this.getItemIndex("parentId")].type = "select";
        this.items[this.getItemIndex("isEquipmentMaterials")].type = "kong";
        this.forms.isEquipmentMaterials = 0;
      }
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {
        isParent: 1,
      };
      // q.state=1
      $utils.api.load("/admin/system/consumableType/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.model;
            xx.children = element.children || [];
            console.log(xx.value, this.editDetail.id);
            if (this.editDetail.id != xx.value) {
              dropList.push(xx);
            }
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "parentId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
  },
};
</script>
